<template>
  <div class="loading-in">
    <div class="loading-wraper" :class="{'filter-blur':followModal==true||Modal}">
        <div class="course-title">
            {{courseDetial.courseName}}
        </div>
        <div class="author" v-if="ocId">
            <span>{{courseDetial.teacherName}}</span><span>&nbsp;老师</span>
        </div>
        <div class="loading-text">
            等待中
        </div>
        <div class="loadign-intro">
            手机上发起或进入活动进行投屏
        </div>
        <div class="follow">
            <span class="erweima" @click="showFollowModal">点击查看二维码</span>
            <span class="text">关注“财道书院”公众号,及时接收活动通知</span>
        </div>
    </div>
    <div class="operation">
          <div class="stu-enter" @click="exitScreen">
            <span class="iconfont icon-tuichu activity-icon"></span> 
            <span class="text">退出投屏</span> 
          </div>
          <div class="sponsor-activity" v-if="ocId">
            <span class="iconfont icon-faqihuodong activity-icon"></span> 
            <span class="text">发起活动</span> 
            <ul class="activity-box">
              <!-- <li @click="showModal(4)"><img src="../../common/img/act_diss.svg" class="taolun"/> <span class="text">讨论</span></li> -->
              <li @click="showModal(3)"><img src="../../common/img/act_sign.svg" class="qiangda"/> <span class="text">抢答</span></li>            
              <!-- <li @click="showModal(5)"><img src="../../common/img/pick.png" class="xuanren"/> <span class="text">选人</span></li>             -->
              <li @click="showModal(2)"><img src="../../common/img/act_vote.svg" class="toupiao"/> <span class="text">投票</span></li>
              <li @click="showModal(1)"><img src="../../common/img/act_askandanswer@3x.svg" class="dianming"/> <span class="text">点名</span></li>
            </ul>
          </div>
    </div>
    <modal :type="type" :modal="Modal" :modalTitle="modalTitle"  @closeModal="closeModal"></modal>
    <div class="follow-modal" v-if="followModal" @click="closeFollowModal">
        <div class="modal-title">关注公众号，接收/参与活动</div>
        <div class="erweima">
            <img src="../../common/img/erweima.png" alt="">
            <div class="close" @click="closeFollowModal"><span class="iconfont icon-guanbi"></span></div>
        </div>
    </div>
  </div>
</template>

<script>
import modal from '@/components/modal/modal/'
import common from '../../common/js/common';
export default {
  name: 'loadingIn',
  data () {
    return {
      title:'2018-11-20 12:00点名',
      type:0,
      Modal:false,
      activity:['点名','投票','抢答','讨论','选人'],    
      modalTitle:"" ,
      followModal:false,
      courseDetial:[],
      userId:0,
      ocId:common.getCookie('ocId')
    }
  },
  methods:{
    getCourseDetial:function(){
       var that = this;
       var ocId = this.common.getCookie('ocId');
       var userId = this.common.getCookie('userId');
       var Authorization= this.common.getCookie('Authorization')
       that.$http.get(that.baseURL+'/appscreen/getCourseAndTeacherName/'+userId+'/'+ocId,{headers: {
            'Authorization': Authorization
        }}).then((res)=>{
           var data = res.data;
           that.courseDetial = data;
       })
    },
    showModal:function(type){
      this.type = type;
      this.Modal = true;
      this.modalTitle = this.common.getDate()+this.activity[this.type-1];
    },
    closeModal:function(){
      this.Modal = false;
    },
    showFollowModal:function(){
        this.followModal = true;
    },
    closeFollowModal:function(){
        this.followModal = false;
    },
    exitScreen:function(){
      var channel = this.common.getCookie('channel');
      var userId = this.common.getCookie('userId');
      var that = this;
      that.$http.get(that.baseURL+'/appscreen/closeConnection?userId='+userId+'&channel='+channel).then((res)=>{
        if(res.data.status == 'success'){
          that.common.delCookie('userId');
          that.common.delCookie('type');
          that.common.delCookie('screenKey');
          that.common.delCookie('activityId');
          that.common.delCookie('ocId');
          that.common.delCookie('channel');
          that.common.delCookie('Authorization');
          that.$router.replace({ name: 'screenEnter'})
        }
      })
    }
  },
  computed:{

  },
  created:function(){

    if(common.getCookie('ocId')){
      this.getCourseDetial()
    }
  },
  mounted:function(){
  },
  watch:{
  },
  components:{modal}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import 'loadingIn.scss'
</style>



// WEBPACK FOOTER //
// src/components/loadingIn/loadingIn.vue